import { useQuery } from '@tanstack/react-query';
import { getBookDetail } from '../api/books';
import type { Book } from '../api/books';

interface UseBookDetailOptions {
  onSuccess?: (data: Book) => void;
  onError?: (error: Error) => void;
  enabled?: boolean;
}

export const useBookDetail = (
  bookId: number | null,
  options: UseBookDetailOptions = {}
) => {
  return useQuery<Book, Error>({ 
    queryKey: ['book', bookId], // Query key includes the book ID
    queryFn: () => getBookDetail(bookId!),
    enabled: !!bookId && (options.enabled !== false), // Fetch only if bookId is provided
    ...options,
  });
};
